import React from 'react';

export interface StreamingMessageWrapperProps {
  children: React.ReactNode;
  isStreaming: boolean;
  className?: string;
}

/**
 * Simple wrapper component for streaming messages.
 * The scroll-to-bottom functionality is now handled by the parent ThreadsCanvas component.
 */
export const StreamingMessageWrapper: React.FC<StreamingMessageWrapperProps> = ({
  children,
  className = '',
}) => {
  return (
    <div className={`relative ${className}`}>
      {children}
    </div>
  );
};

export default StreamingMessageWrapper;
